import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";
import { Controller, useFormContext } from "react-hook-form";
import SelectLojaComPesquisa, { TLoja } from "../../../../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa";
import {
  formatarInputValorMonetário,
  permitirApenasNumeros,
} from "../../../../../../../../helpers/masks";
import BasicDatePicker from "../../../../../../../../components/BasicDatePicker";
import SelectPlanoContas from "../../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas";
import SelectCentroCusto from "../../../../../../../../components/SelectsSimpleApiQuery/SelectCentroCusto";
import moment from "moment";

export default function DialogEditDadosPagamento({
  open,
  handleClose,
}: DialogEditDadosPagamentoProps) {
  const { handleSubmit, control, getValues, watch, setValue } =
    useFormContext();

  const praca = watch("praca");

  const isSubmitting = watch("loading");
  const onSubmit = getValues("onSubmit");

  const handleAtualizar = (data: any) => {
    onSubmit(data);
    handleClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperDraggable}
        aria-labelledby="draggable-dialog-title"
        fullWidth
        maxWidth={"md"}
        scroll="body"
      >
        <DialogTitle
          style={{ cursor: "move", paddingBottom: 0 }}
          id="draggable-dialog-title"
        >
          Editar dados de pagamento
        </DialogTitle>

        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} pt={3}>
              <Grid size={{ xs: 6, md: 3 }}>
                <Controller
                  name="detalhe.dadosPagamento.loja"
                  rules={{ required: "Campo obrigatório" }}
                  control={control}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <SelectLojaComPesquisa
                      value={field.value}
                      required
                      error={invalid}
                      errorMessage={error?.message}
                      onChange={(value) => {
                        const valor = value as TLoja;
                        field.onChange(valor);
                        if (praca === "") {
                          setValue("praca", valor?.cidade || "");
                        }
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 6, md: 3 }}>
                <Controller
                  name="detalhe.dadosPagamento.lote"
                  rules={{ required: "Campo obrigatório" }}
                  control={control}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <TextField
                      label="Lote"
                      value={field.value || ""}
                      required
                      error={invalid}
                      fullWidth
                      onChange={(e) => {
                        const newValue = permitirApenasNumeros(e.target.value);
                        field.onChange(newValue);
                      }}
                      slotProps={{ htmlInput: { maxLength: 6 } }}
                      helperText={invalid ? error?.message : ""}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                  name="detalhe.dadosPagamento.data_origem"
                  control={control}
                  rules={{ required: "Campo obrigatório" }}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <BasicDatePicker
                      label="Data de origem *"
                      helperText={error ? error.message : ""}
                      error={invalid}
                      value={
                        field.value ? moment(field.value, "DD/MM/YYYY") : null
                      }
                      onChange={(data) => field.onChange(data)}
                      formatString="DD/MM/YYYY"
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                  name="detalhe.dadosPagamento.valor"
                  control={control}
                  rules={{ required: "Campo obrigatório" }}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <TextField
                      label="Valor"
                      required
                      fullWidth
                      error={invalid}
                      helperText={error ? error.message : ""}
                      value={formatarInputValorMonetário(field.value)}
                      onChange={(e) => {
                        const formattedValue = formatarInputValorMonetário(
                          e.target.value
                        );
                        field.onChange(formattedValue);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                  name="detalhe.dadosPagamento.conta_devedora"
                  control={control}
                  rules={{ required: "Campo obrigatório" }}
                  render={({ field, fieldState: { invalid } }) => (
                    <SelectPlanoContas
                      inputLabel="Conta devedora"
                      value={field.value}
                      required
                      error={invalid}
                      onChangeValue={(valor) => field.onChange(valor)}
                      extraParams={{ sistema_xy: "D-CHE" }}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                  name="detalhe.dadosPagamento.contra_partida"
                  control={control}
                  rules={{ required: "Campo obrigatório" }}
                  render={({ field, fieldState: { invalid } }) => (
                    <SelectPlanoContas
                      inputLabel="Contra partida"
                      value={field.value}
                      required
                      error={invalid}
                      onChangeValue={(valor) => field.onChange(valor)}
                      extraParams={{ tipo: "Analítica" }}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                  name="detalhe.dadosPagamento.departamento_centro_custo"
                  control={control}
                  rules={{ required: "Campo obrigatório" }}
                  render={({ field, fieldState: { invalid } }) => (
                    <SelectCentroCusto
                      value={field.value}
                      required
                      error={invalid}
                      onChange={(valor) => field.onChange(valor)}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                  name="detalhe.dadosPagamento.praca"
                  control={control}
                  render={({ field, fieldState: { invalid, error } }) => (
                    <TextField
                      label="Praça"
                      value={field.value || ""}
                      error={invalid}
                      fullWidth
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      slotProps={{ htmlInput: { maxLength: 20 } }}
                      helperText={invalid ? error?.message : ""}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Controller
                  name="detalhe.dadosPagamento.data_vencimento"
                  control={control}
                  rules={{ required: "Campo obrigatório" }}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <BasicDatePicker
                      label="Vencimento *"
                      helperText={error ? error.message : ""}
                      error={invalid}
                      value={
                        field.value ? moment(field.value, "DD/MM/YYYY") : null
                      }
                      onChange={(data) => field.onChange(data)}
                      formatString="DD/MM/YYYY"
                    />
                  )}
                />
              </Grid>
            </Grid>

            <DialogActions>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button
                disabled={isSubmitting}
                variant="contained"
                type="submit"
                onClick={handleSubmit(handleAtualizar)}
              >
                {isSubmitting && (
                  <CircularProgress size={20} sx={{ marginRight: 1 }} />
                )}
                Salvar
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}

interface DialogEditDadosPagamentoProps {
  open: boolean;
  handleClose: () => void;
}
